module.exports = __webpack_public_path__ + "images/404_background.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/404_background.jpg
// module id = 24
// module chunks = 1